import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import ContestOfferCard from "@/components_v3/affiliate/contest/entities/cashback-offer/ui/contest-offer-card/ContestOfferCard.vue";
import ContestOfferGoalsTable from "@/components_v3/affiliate/contest/entities/cashback-offer/ui/contest-offer-goals-table/ContestOfferGoalsTable.vue";
import {
    IContestCashbackGoal,
    IContestCashbackOffer,
    IContestSpecialPeriod,
} from "@/components_v3/affiliate/contest/entities/cashback-offer/model/types";
import AddOfferButton from "@/components_v3/affiliate/contest/features/offer-add/ui/add-offer-button/AddOfferButton.vue";
import ContestOfferCardHeader from "@/components_v3/affiliate/contest/features/offer-edit/ui/contest-offer-card-header/ContestOfferCardHeader.vue";
import type { ContestOfferDraft } from "@/components_v3/affiliate/contest/model/types";

interface Props {
    title: string;
    offers: IContestCashbackOffer[];
    emptyText: string;
    month: string;
    draft: ContestOfferDraft;
    isAddActive: boolean;
    isSubmitting: boolean;
    isGoalsLoading: boolean;
    canSave: boolean;
    isEditingOffer: (offerId: number) => boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestOfferSection',
  props: {
    title: null,
    offers: null,
    emptyText: null,
    month: null,
    draft: null,
    isAddActive: { type: Boolean },
    isSubmitting: { type: Boolean },
    isGoalsLoading: { type: Boolean },
    canSave: { type: Boolean },
    isEditingOffer: null
  },
  emits: ["edit", "delete", "save", "cancel", "start-add", "update:offer-id", "update:plan", "update:goals", "update:special-period-enabled", "update:special-period"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'edit', offer: IContestCashbackOffer): void;
    (e: 'delete', offer: IContestCashbackOffer): void;
    (e: 'save'): void;
    (e: 'cancel'): void;
    (e: 'start-add'): void;
    (e: 'update:offer-id', offerId: number | null): void;
    (e: 'update:plan', plan: number | null): void;
    (e: 'update:goals', goals: IContestCashbackGoal[]): void;
    (e: 'update:special-period-enabled', enabled: boolean): void;
    (e: 'update:special-period', period: IContestSpecialPeriod | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    title: string;
    offers: IContestCashbackOffer[];
    emptyText: string;
    month: string;
    draft: ContestOfferDraft;
    isAddActive: boolean;
    isSubmitting: boolean;
    isGoalsLoading: boolean;
    canSave: boolean;
    isEditingOffer: (offerId: number) => boolean;
}





const offerColumns = computed(() => {
    const left: IContestCashbackOffer[] = [];
    const right: IContestCashbackOffer[] = [];

    props.offers.forEach((offer, index) => {
        if (index % 2 === 0) {
            left.push(offer);
        } else {
            right.push(offer);
        }
    });

    return [left, right];
});

function isEditing(offer: IContestCashbackOffer): boolean {
    return props.isEditingOffer(offer.offerId);
}

function resolveOfferId(offer: IContestCashbackOffer): number {
    return isEditing(offer) && props.draft.offerId != null
        ? props.draft.offerId
        : offer.offerId;
}

function resolveOfferName(offer: IContestCashbackOffer): string | null {
    return isEditing(offer) ? props.draft.offerName : offer.offerName;
}

function resolvePlan(offer: IContestCashbackOffer): number | null {
    return isEditing(offer) ? props.draft.plan : (offer.customGoal ?? null);
}

function resolveGoals(offer: IContestCashbackOffer): IContestCashbackGoal[] {
    return isEditing(offer) ? props.draft.goals : offer.goals;
}

function resolveSpecialPeriodEnabled(offer: IContestCashbackOffer): boolean {
    return isEditing(offer) ? props.draft.specialPeriodEnabled : offer.specialPeriodEnabled;
}

function resolveSpecialPeriod(offer: IContestCashbackOffer): IContestSpecialPeriod | null {
    return isEditing(offer) ? props.draft.specialPeriod : offer.specialPeriod;
}

function resolveShowPeriodBonusColumn(offer: IContestCashbackOffer): boolean {
    return isEditing(offer) ? props.draft.specialPeriodEnabled : offer.specialPeriodEnabled;
}

return { __sfc: true,props, emit, offerColumns, isEditing, resolveOfferId, resolveOfferName, resolvePlan, resolveGoals, resolveSpecialPeriodEnabled, resolveSpecialPeriod, resolveShowPeriodBonusColumn, ContestOfferCard, ContestOfferGoalsTable, AddOfferButton, ContestOfferCardHeader }
}

})